import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Input, Col, Select} from 'antd'
import {SearchOutlined, PlusOutlined} from '@ant-design/icons'
import FormModal from './FormModal'
import UPM from '../../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'

@inject('mappingManagementStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
    inboundValue: '',
    outboundValue: '',
  }
  formRef = React.createRef()

  componentDidMount() {
  }

  handleSearch = () => {
    const {mappingManagementStore} = this.props
    const {pageSize} = mappingManagementStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let value = {
        mappingName: fieldsValue.mappingName,
        inboundCustomer: fieldsValue.inboundCustomer,
        inBoundApiId: fieldsValue.inBoundName,
        outboundCustomer: fieldsValue.outboundCustomer,
        outBoundApiId: fieldsValue.outBoundName,
        status: fieldsValue.status === '' ? null : fieldsValue.status,
        mappingAttribute: fieldsValue.mappingAttribute,
        mappingType: fieldsValue.mappingType,

      }
      mappingManagementStore.onChangePageNo()
      mappingManagementStore.onSearchAction(value, 1, pageSize)
    }).catch(err => {})
  }
  /*inboundCustomer*/
  onChangeInbound = (value) => {
    const {mappingManagementStore} = this.props
    this.formRef.current.setFieldsValue({
      inBoundName: undefined
    })
    if (value === undefined) {
      this.setState({
        inboundValue: ''
      })
    } else {
      mappingManagementStore.onGetInboundNameAction(value)
      this.setState({
        inboundValue: value
      })
    }
  }
  onChangeOutbound = (value) => {
    const {mappingManagementStore} = this.props
    this.formRef.current.setFieldsValue({
      outBoundName: undefined
    })
    if (value === undefined) {
      this.setState({
        outboundValue: ''
      })
    } else {
      mappingManagementStore.onGetOutboundNameAction(value)
      this.setState({
        outboundValue: value
      })
    }
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {mappingManagementStore, location, t} = this.props
    const {inboundCustomerList, inboundNameList, outboundCustomerList, outboundNameList} = mappingManagementStore
    const mappingTypeList = [
      {label: 'Request', value: 'Request'},
      {label: 'Response', value: 'Response'}
    ]
    const mappingAttributeList = [
      {label: 'Base', value: 'Base'},
      {label: 'Groovy', value: 'Groovy'},
      {label: 'None', value: 'None'},
      {label: 'OnlyCopy', value: 'OnlyCopy'}
    ]
    return (
      <>
        <Form ref={this.formRef} initialValues={{}} className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 0]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="inboundCustomer" label={t(`mappingManagement.inboundCustomer`)}
                         rules={[{message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.inboundCustomer`)}`,}]}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeInbound} showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {inboundCustomerList.length > 0 ? inboundCustomerList.map(item => <Select.Option key={item.id}
                                                                                                   value={item.id}>{item.customer}</Select.Option>) : null}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="inBoundName" label={t(`mappingManagement.inboundName`)}
                         rules={[{message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.inboundName`)}`,}]}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled={this.state.inboundValue === ''} showSearch
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                  {inboundNameList.map(item => <Select.Option key={item.id} value={item.id}>{item.apiName}</Select.Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="outboundCustomer" label={t(`mappingManagement.outboundCustomer`)}
                         rules={[{message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.outboundCustomer`)}`,}]}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeOutbound} showSearch
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                  {outboundCustomerList.length > 0 ? outboundCustomerList.map(item => <Select.Option key={item.id}
                                                                                                     value={item.id}>{item.customer}</Select.Option>) : null}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="outBoundName" label={t(`mappingManagement.outboundName`)}
                         rules={[{message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.outboundName`)}`,}]}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled={this.state.outboundValue === ''} showSearch
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                  {outboundNameList.map(item => <Select.Option key={item.id} value={item.id}>{item.apiName}</Select.Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="mappingName" label={t(`mappingManagement.mappingName`)}
                         rules={[{
                           message: `${t(`general.pleaseEnter`)} ${t(`mappingManagement.mappingName`)} ${t(`general.withoutSpecialChats`)}`,
                           pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                         }]}>
                <Input placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="status" label={t(`mappingManagement.status`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  <Select.Option key="Normal" value="Normal">NORMAL</Select.Option>
                  <Select.Option key="Freeze" value="Freeze">FREEZE</Select.Option>
                  <Select.Option key="Abnormal" value="Abnormal">ABNORMAL</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="mappingType" label={t(`mappingManagement.mappingType`)} defaultValue="Request">
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  {mappingTypeList.length > 0 ? mappingTypeList.map(item => <Select.Option key={item.value}
                                                                                           value={item.value}>{item.label}</Select.Option>) : null}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="mappingAttribute" label={t(`mappingManagement.mappingAttribute`)} defaultValue="Base">
                <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeMappingAttribute}>
                  {mappingAttributeList.length > 0 ? mappingAttributeList.map(item => <Select.Option key={item.value}
                                                                                                     value={item.value}>{item.label}</Select.Option>) : null}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8} offset={8} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title=""
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
